import { Component, Input, OnInit } from '@angular/core';
import { BreadCrumbService } from '@services/cleanfill-core/breadcrumb/bread-crumb.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() isAdmin: boolean;

  breadcrumbs: string[];

  constructor(private bcService: BreadCrumbService) {}

  ngOnInit(): void {
    this.breadcrumbs = this.bcService.buildBreadCrumb();
  }
}
